import { useEffect } from 'react';
import './Main.css';

const Main = ({ scrollbar }) => {
	return (
		<div className="main">
			<h1>
				IDENTYFIKACJA WIZUALNA<br></br> STRONY <br></br> WWW
			</h1>
			<p className="author">&#169;2022 Marko Kaczorowski</p>
			<button
				onClick={() => {
					if (scrollbar) {
						scrollbar.scrollTo(0, 1135, 1000);
					}
				}}
			>
				<i className="far fa-arrow-down"></i>
				<p>Wybrane realizacje</p>
			</button>
		</div>
	);
};

export default Main;
